import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

export const INTERNAL_LINK_CLASSES = "inline items-center text-blue-600 dark:text-blue-400 hover:underline";
export const INTERNAL_LINK_ICON_CLASSES = "inline ml-1 mr-1 align-text-bottom text-inherit !text-gray-500";

const InternalLink = ({ href, children, className, ...props }) => {
  const fullText = React.Children.toArray(children).map(c => (typeof c === 'string' ? c : '')).join('') || href;

  let displayHost = '';
  try {
    const urlObj = new URL(href);
    displayHost = urlObj.hostname;
  } catch {}

  const isInternalUrl = [
    'http://localhost:3000',
    'https://stage.cadencepro.ai',
    'https://cadencepro.ai',
    'https://www.cadencepro.ai',
    'https://dev.azure.com',
  ].some(prefix => href && href.startsWith(prefix));

  if (!href || isInternalUrl) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={INTERNAL_LINK_CLASSES}
        {...props}
      >
        <span className="whitespace-normal">
          {" "}{children || fullText}

          {href && (
            <FaExternalLinkAlt className={INTERNAL_LINK_ICON_CLASSES} />
          )}
        </span>
      </a>
    );
  }

  const shortHost = (displayHost || '').replace(/^www\./, '');
  const faviconSrc = displayHost ? `https://www.google.com/s2/favicons?domain=${displayHost}&sz=64` : '';

  return (
    <span className="research-pill-wrap">
      <a href={href} target="_blank" rel="noopener noreferrer" className="research-pill" {...props}>
        {faviconSrc ? <img src={faviconSrc} alt="" className="w-3 h-3 rounded-full inline-block" /> : null}
        <span className="ml-1 opacity-70 truncate max-w-[100px]">{shortHost}</span>
      </a>
      <span className="pill-tooltip">
        <div className="pill-tooltip-card">
          <div className="pill-tooltip-header">
            {faviconSrc ? <img src={faviconSrc} alt="" className="pill-tooltip-favicon" /> : null}
            <span className="pill-tooltip-domain">{displayHost}</span>
          </div>
          <div className="pill-tooltip-title">{fullText}</div>
        </div>
      </span>
    </span>
  );
};

export default InternalLink;
